import { FC } from 'react';

import { useBodyScrollLock } from '@/shared/hooks/useBodyScrollLock';

import { useModalsStore } from './modals.store';
import { ModalsRouter } from './ModalsRouter';

export const ModalsContainer: FC = () => {
  const modals = useModalsStore();

  useBodyScrollLock(modals.isOpened);

  if (!modals.isOpened || !modals.data) {
    return null;
  }

  // TODO add error bounder container
  return <ModalsRouter data={modals.data} />;
};
